export const RECYCLABILITY_STATUSES = {
  RECYCLABLE: 'Recyclable',
  NON_RECYCLABLE: 'Non-Recyclable',
  COLLECTED: 'Collected',
}

export const ICON_STATUSES = {
  RECYCLABLE: {
    ENGLISH: 'Recyclable',
    FRENCH: 'Recyclable',
  },
  NON_RECYCLABLE: {
    ENGLISH: 'Non recyclable',
    FRENCH: 'Non recyclable',
  },
  COLLECTED: {
    ENGLISH: 'Collected',
    FRENCH: 'Collecté',
  },
}

export const RECYCLABILITY_COUNTRIES = {
  CANADA: 'Canada',
  HONG_KONG: 'Hong Kong',
}
